<template>
  <div class="back-fff">
    <div class="security_box">
      <!--手机验证-->
      <div class="security_box_item">
        <div class="security_line_box">
          <div class="icon_img">
            <i class="iconfont phone-icon">&#xe643;</i>
          </div>
          <h3 class="title">{{ $t('key1005505') }}</h3>
          <p class="text">{{ userInfo.mobile }}</p>
        </div>
        <div class="options_button" v-if="getPermission('ymsDistributorMerchant_updateMobile')" @click="editBtn('phone')">{{ $t('key1003510') }}</div>
      </div>
      <!--邮箱验证-->
      <div class="security_box_item">
        <div class="security_line_box">
          <div class="icon_img">
            <i class="iconfont email-icon">&#xe61a;</i>
          </div>
          <h3 class="title">{{ $t('key1005506') }}</h3>
          <p class="text">{{ userInfo.email }}</p>
        </div>
        <div class="options_button" v-if="getPermission('ymsDistributorMerchant_updateEmail')" @click="editBtn('email')">{{ $t('key1003510') }}</div>
      </div>
      <!--登录密码-->
      <div class="security_box_item">
        <div class="security_line_box">
          <div class="icon_img">
            <i class="iconfont email-icon">&#xe60b;</i>
          </div>
          <h3 class="title">{{ $t('key1005507') }}</h3>
          <p class="text red_style">{{ $t('key1005508') }}</p>
        </div>
        <div class="options_button" v-if="getPermission('ymsDistributorMerchant_updatePassword')" @click="editBtn('password')">{{ $t('key1003510') }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.security_box {
  width: 100%;
  height: 549px;

  .security_box_item {
    padding: 30px 10px;
    border-bottom: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    box-sizing: border-box;

    .security_line_box {
      display: flex;
      align-items: center;

      .icon_img {
        width: 36px;
        height: 36px;
        background: #FFFFFF;
        border: 1px solid #DCDEE2;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        .phone-icon {
          font-size: 20px;
          color: #C5C8CE;
        }

        .email-icon {
          font-size: 19px;
          color: #C5C8CE;
        }
      }

      .title {
        margin: 0 55px 0 20px;
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bolder;
        color: #1D1D1D;
      }

      .text {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #1D1D1D;
      }

      .red_style {
        color: #FF0000;
        font-weight: bold;
      }
    }

    .options_button {
      width: 60px;
      height: 26px;
      margin-left: 40px;
      background: #FFFFFF;
      border: 1px solid #FD5425;
      border-radius: 2px;
      line-height: 25px;
      box-sizing: border-box;
      text-align: center;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #FD5425;
      cursor: pointer;
    }
  }
}
</style>

<script>
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "securityInformation",
  mixins: [Mixin],
  data() {
    return {};
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 进入对应的修改页面
    editBtn(type) {
      // 修改手机
      if (type === 'phone') {
        this.$router.push('/modifyMobile');
      }
      // 修改邮箱
      else if (type === 'email') {
        this.$router.push('/modifyMailbox');
      }
      // 修改登录密码
      else if (type === 'password') {
        this.$router.push('/modifyPassword');
      }
    }
  }
};
</script>
